// import { div, span } from '@tarojs/components';
import classNames from 'classnames';
import styles from './index.module.less';

function PrivacyPolicyZH() {
  return (
    <div className={styles.wrapper}>
      <div className={styles.serviceAgreement}>
        <div className={styles.title}>
          更新日期：【2023】年【10】 月【30】日
        </div>
        <div className={styles.title}>引言</div>
        <div>
          欢迎您使用我们的产品和服务！碳阻迹（北京）科技有限公司（以下简称“碳阻迹”或者“我们”）深知个人信息对您的重要性，我们将根据法律法规要求尊重并保护所有使用我们提供的碳阻迹服务的用户（以下简称“您”）的个人隐私权。为了给您提供更准确、更有个性化的服务，我们会按照《隐私政策》（以下简称“本政策”或“本隐私政策”）的约定处理和使用您的个人信息。
        </div>
        <div className={styles.bold}>本政策将帮助您了解以下内容：</div>
        <div>一、我们如何收集和使用您的个人信息</div>
        <div>二、我们如何使用 Cookie 和同类技术</div>
        <div>三、我们如何共享、转让和公开披露您的个人信息</div>
        <div>四、我们如何保存和保护您的个人信息</div>
        <div>五、您的权利</div>
        <div>六、我们如何处理未成年人的个人信息</div>
        <div>七、您的个人信息如何在全球范围转移</div>
        <div>八、本政策如何更新</div>
        <div>九、如何联系我们</div>
        <div>
          本隐私政策适用于碳阻迹官方网站及/或使用碳阻迹提供的所有产品和服务。
          我们将在遵守国家法律法规规定的前提下，以向您提供碳阻迹的产品及服务并不断提升产品及服务质量为目的收集、使用、共享您的个人信息，同时我们将全力保障您的个人信息安全。
          请在使用我们的产品(或服务)前，仔细阅读并了解本《隐私政策》，特别是以
          <span className={classNames(styles.underline, styles.bold)}>
            粗体/粗体下划线
          </span>
          标识的条款，您应重点阅读，确认您充分理解并同意后再开始使用。
        </div>
        <div className={styles.title}>定义</div>
        <div>
          1.{' '}
          <span className={styles.bold}>
            <span>碳阻迹：</span>
          </span>
          指研发并提供碳阻迹产品和服务的主体，即碳阻迹（北京）科技有限公司，以及现在或未来设立的相关关联公司的单称或合称。
        </div>
        <div>
          2.{' '}
          <span className={styles.bold}>
            <span>碳阻迹产品/服务：</span>
          </span>
          是指由碳阻迹开发和服务的Carbon
          AI产品，帮助客户进行安全、高效的碳数据量化服务，助力企业绿色可持续发展。
        </div>
        <div>
          3.{' '}
          <span className={styles.bold}>
            <span>碳阻迹网站：</span>
          </span>
          碳阻迹为用户提供服务的互联网网址为官网(www.carbonstop.com)、碳云SaaS(ccloud.carbonstop.com)。
        </div>
        <div>
          4. <span className={styles.bold}>个人信息：</span>
          指以电子或者其他方式记录的已识别或者与可识别的自然人有关的各种信息，不包括匿名化处理后的信息。
        </div>
        <div>
          5. <span className={styles.bold}>敏感个人信息：</span>
          指一旦泄露或者非法使用，容易导致自然人的人格尊严受到侵害或者人身、财产安全受到危害的个人信息，包括生物识别、宗教信仰、特定身份、医疗健康、金融账户、行踪轨迹等信息，以及不满十四周岁未成年人的个人信息。在本隐私政策中还包括：网络行踪轨迹、精确定位信息、交易记录。
        </div>
        <div>
          6. <span className={styles.bold}>个人信息删除：</span>
          指在实现日常业务功能所涉及的系统中去除个人信息的行为，使其保持不可被检索、访问的状态。
        </div>
        <div className={styles.title}>一、我们如何收集和使用您的个人信息</div>
        <div>
          为了向您提供碳阻迹产品和/或服务的基本功能，我们需要处理您的必要的个人信息，如您拒绝提供前述必要信息，您将无法正常使用碳阻迹产品和/或服务的基本功能。对于您可选填或选择提供的个人信息，如您拒绝提供，我们可能无法向您提供依赖该等信息的部分特定功能，但并不会影响您正常使用碳阻迹产品和/或服务的基本功能。
        </div>
        <div>
          碳阻迹会遵循正当、合法、必要的原则，在以下提供碳阻迹产品和/或服务的场景中收集您的个人信息。如您提供的个人信息非本人信息，您应确保您已获得该人的授权同意。
        </div>
        <div>
          (一) 服务信息展示
          当您使用碳阻迹服务时，为保障您正常使用我们的服务，我们会收集您的{' '}
          <span className={styles.bold}>
            设备名称（包括别名）、设备型号、操作系统、IP地址、设备软件版本信息、设备识别码、设备标识码、信息所在地区、网络使用习惯以及其他与碳阻迹服务相关的日志信息，
          </span>{' '}
          这类信息是为提供服务必须收集的基础信息，如您不同意我们记录前述信息，可能无法完成风控验证。
        </div>
        <div>
          <span className={classNames(styles.bold, styles.underline)}>
            请注意，单独的设备信息、日志信息是无法识别特定自然人身份的信息。
          </span>
          如果我们将这类非个人信息与其他信息结合用于识别特定自然人身份，或者将其与个人信息结合使用，则在结合使用期间，这类非个人信息将被视为个人信息，除取得您授权或法律法规另有规定外，我们会将该类个人信息做匿名化、去标识化处理。
        </div>
        <div className={styles.title}>(二) 账号注册</div>
        <div>
          在注册使用碳阻迹服务时，您需要提供{' '}
          <span className={styles.bold}>
            手机号、邮箱、姓名、公司名称、密码或验证码
          </span>{' '}
          用于创建账户完成注册，如您在使用过程中对账户信息进行修改，该修改信息也会同步至您的账号中。如您不同意提供上述信息，我们将无法为您创建账户并正常向您提供服务。对于需要通过登录账号才能使用的服务，我们可能会根据您提供的上述信息校验您的身份，确保我们是在为您本人提供服务。
        </div>
        <div className={styles.title}>(三) 快捷登录</div>
        <div>
          您使用手机号码或邮箱登录时，我们会向您预留的手机号或邮箱发送验证码以便于您快捷的完成登录，并保证您账号的安全性。
        </div>
        <div className={styles.title}>（四）消息推送</div>
        <div>
          您需要填写 <span className={styles.bold}>邮箱地址</span>{' '}
          ，我们会通过邮件、站内信的方式，根据您使用服务的实际情况来分类推送服务信息。如：供应商管理、任务提醒等。如您不提供相关信息，我们将无法正常为您提供上述服务。
        </div>
        <div className={styles.title}>（五）客服及争议处理</div>
        <div>
          当您与我们联系时，我们可能会保存您的{' '}
          <span className={styles.bold}>通信/通话记录和内容</span> 或您留下的
          <span className={styles.bold}>联系方式信息</span>
          ，以便与您联系或帮助您解决问题，或记录相关问题的处理方案及结果。
        </div>
        <div className={styles.title}>（六）用户邀请</div>
        <div>
          当您邀请其他用户加入我们时，您需要在获得对方合法有效授权后填写对方的
          <span className={styles.bold}>姓名、手机号或是邮箱地址</span>
          ，这些信息仅会被用来给您的联系人发出邀请或是其他信息之用。您也可以自行为您的联系人填加一些个人信息，但是我们保证这些信息仅会被您看到。您为您联系人所填信息也符合此隐私政策。
        </div>
        <div className={styles.title}>（七）其他用途</div>
        <div>
          我们将信息用于本政策未载明的其他用途，或者将基于特定目的收集而来的信息用于其他目的时，会事先征求您的同意。
        </div>
        <div className={styles.title}>（八）征得授权同意的例外</div>
        <div>
          根据相关法律法规规定，以下情形中收集及使用您的个人信息无需征得您的授权同意：
        </div>
        <div>1. 与国家安全、国防安全有关的；</div>
        <div>2. 与公共安全、公共卫生、重大公共利益有关的；</div>
        <div>3. 与犯罪侦查、起诉、审判和判决执行有关的；</div>
        <div>
          4.
          出于维护个人信息主体或其他个人的生命、财产重大合法权益但又很难得到您本人同意的；
        </div>
        <div>5. 所收集的个人信息是您自行向社会公众公开的；</div>
        <div>
          6.
          从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开渠道；
        </div>
        <div>7. 根据您的要求签订合同所必需的；</div>
        <div>
          8.
          为了履行与您订立的合同，维护所提供的产品或服务的安全稳定运行所必需的；
        </div>
        <div>9. 法律法规规定无需征得授权的其他情形。</div>
        <div>
          如我们停止运营碳阻迹产品或服务，我们将及时停止继续收集及使用您个人信息的活动，将停止运营的通知以逐一告知或公告的形式通知您，对所持有的个人信息进行删除或匿名化处理。
        </div>
        <div className={styles.title}>二、我们如何使用Cookie和同类技术</div>
        <div>
          为确保网站正常运转、为您获得更轻松的访问体验，我们会在您的计算机或移动设备上存储名为
          Cookie 的小数据文件。Cookie
          通常包含标识符、站点名称以及一些号码和字符。我们不会在Cookie里面存储与个人身份或隐私相关的信息。
        </div>
        <div>
          您可根据自己的偏好管理或删除 Cookie。有关详情，请参见
          AboutCookies.org。您可以清除计算机上保存的所有
          Cookie，大部分网络浏览器都设有阻止Cookie
          的功能。但如果您这么做，则需要在每一次访问我们的网站时更改用户设置。如需详细了解如何更改浏览器设置，请访问您使用的浏览器的相关设置页面。
        </div>
        <div className={styles.title}>
          三、我们如何共享、转让和公开披露您的个人信息
        </div>
        <div>
          <span className={styles.bold}>共享</span>
          我们不会与碳阻迹服务提供者以外的公司、组织和个人共享您的个人信息，但以下情况除外：
        </div>
        <div>
          1、在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。
        </div>
        <div>
          2、在法定情形下的共享：我们可能会根据法律法规规定，或按行政、司法机关依法提出的强制性要求，对外共享您的个人信息。
        </div>
        <div>
          3、基于向您提供碳阻迹产品/服务需要，于必要的范围内，如后续我们存在与授权合作伙伴共享您的个人信息等安排的，我们会相应更新本政策。
        </div>
        <div>
          <span className={styles.bold}>转让</span>
          我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：
        </div>
        <div>
          1、在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；
        </div>
        <div>
          2、在碳阻迹服务提供者发生合并、收购或破产清算情形，或其他涉及合并、收购或破产清算情形时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本政策的约束，否则我们将要求该公司、组织和个人重新向您征求授权同意。
        </div>
        <div className={styles.title}>- 公开披露</div>
        <div>我们仅会在以下情况下，公开披露您的个人信息：</div>
        <div>
          1、获得您明确同意或基于您的主动选择，我们可能会公开披露您的个人信息；
        </div>
        <div>
          2、在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。执法机关提出披露要求，我们会及时通知您，除非执法机关另有禁止披露的要求。
        </div>
        <div className={styles.title}>
          - 共享、转让、公开披露个人信息时事先征得授权同意的例外
        </div>
        <div>
          以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：
        </div>
        <div>1. 与国家安全、国防安全有关的；</div>
        <div>2. 与公共安全、公共卫生、重大公共利益有关的；</div>
        <div>3. 与犯罪侦查、起诉、审判和判决执行有关的；</div>
        <div>4. 您自行向社会公众公开的个人信息；</div>
        <div>
          5.
          出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；
        </div>
        <div>
          6. 其他维护公共利益的情形，例如您的信用评价信息需要被公开/共享；
        </div>
        <div>
          7.
          从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开渠道，但是您明确拒绝或者处理该信息侵害您重大利益的除外。
        </div>
        <div className={classNames(styles.bold, styles.underline)}>
          根据法律规定，共享、转让经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。
        </div>
        <div className={classNames(styles.bold, styles.underline)}>
          According to the law, sharing and transferring de-identified personal
          information and ensuring that the recipient of the data cannot recover
          and re-identify the subject of the personal information does not
          constitute an act of sharing, transfer, and public disclosure of
          personal information. Storage and processing of this kind ofdatamay
          not be require your consent.
        </div>

        <div className={styles.title}>提供证明</div>
        <div>
          对于通过碳阻迹签订的数据电文等法律文件的，碳阻迹有权将前述法律文件的签署信息如当事人姓名或者名称、统一社会信用代码证（或者组织机构代码证）等号码、身份证号码、数字证书号码、IP地址、签订时间等披露给数据电文的签约当事人作为法律文件的签订证据。
        </div>
        <div className={styles.title}>四、我们如何保存和保护您的个人信息</div>

        <div>
          <span className={styles.bold}>(一) 个人信息的保存</span>
        </div>

        <div>
          1、
          <span className={styles.bold}>
            保存期限：我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非法律法规有强制的留存要求。
          </span>
          我们判断个人信息的存储期限主要参考以下标准并以其中较长者为准：完成与您相关的交易目的、维护相应交易及业务记录，以应对您可能的查询或投诉；保证我们为您提供服务的安全和质量；您是否同意更长的留存期间；是否存在关于保留期限的其他特别约定或法律法规规定。
          <span className={styles.bold}>
            在超出保留期间后，我们会根据适用法律的要求删除您的个人信息，或使其匿名化处理。在您主动注销账号时，我们将根据法律法规的要求进行数据处理。
          </span>
        </div>

        <div>
          2、保存地域：我们在中华人民共和国境内收集和产生的个人信息，将存储在中国境内，以下情形除外：
          （1）法律法规有明确规定；
          （2）向您告知境外接收方的相关信息（例如境外接收方的名称、联系方式、处理您个人信息的目的、方式和种类以及您向境外接收方行使您的权利的方式和程序等），并获得您的明确授权。
          针对以上情形，我们会确保依据本隐私政策对您的个人信息提供在中华人民共和国境内足够同等的保护。
        </div>

        <div>
          3、终止运营：如果发生终止运营等情形，我们将会至少提前30天通知您，并在终止运营后对您的个人信息根据法律法规的要求进行处理。
        </div>

        <div>
          <span className={styles.bold}>(二) 个人信息的保护措施</span>
        </div>

        <div>
          1、我们已采取符合业界标准的安全防护措施保护您提供的个人信息安全，防止个人信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。在您的浏览器与服务器之间交换数据时受SSL(Secure
          Socket Layer)协议加密保护；我们同时对碳阻迹网站提供 HTTPS(Hyper span
          Transfer Protocol over Secure Socket
          Layer)协议安全浏览方式；我们会使用加密技术提高个人信息的安全性；我们会使用受信赖的保护机制防止个人信息遭到恶意攻击；我们会部署访问控制机制，确保只有授权人员才可访问个人信息；我们会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。
        </div>

        <div>
          2、我们已经取得以下认证：信息系统安全等级保护三级认证、ISO/IEC
          27001信息安全管理体系认证。
        </div>

        <div>
          3、我们会采取合理可行的措施，避免收集无关的个人信息。
          <span className={classNames(styles.bold, styles.underline)}>
            我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。
          </span>
        </div>

        <div>
          4、互联网并非绝对安全的环境，
          <span className={classNames(styles.bold, styles.underline)}>
            我们强烈建议您不要使用非碳阻迹推荐的通信方式发送个人信息。
          </span>
          请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息尤其是您的账户或密码发生泄露，请您立即联络碳阻迹客服，以便我们根据您的申请采取相应措施。
          请使用复杂密码，协助我们保证您的账号安全。我们将尽力保障您发送给我们的任何信息的安全性。如果我们的物理、技术或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。
        </div>

        <div>
          5、在不幸发生个人信息安全事件后，我们将按照法律法规的要求及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施。事件相关情况我们将以邮件、信函、电话或推送通知的方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，上报个人信息安全事件的处置情况。
        </div>

        <div>
          6、您通过碳阻迹平台提交个人信息，代表您同意并授权给碳阻迹收集、使用、共享和保护您的个人信息，若您因特殊原因申请撤回授权，请及时联系我们，以便于我们做相应处理。
        </div>

        <div className={styles.title}>五、您的权利</div>

        <div>您可以通过以下方式访问及管理您的个人信息：</div>

        <div>(一) 访问您的个人信息</div>

        <div>
          <div>（二）更正或补充您的个人信息</div>
          当您发现我们处理的关于您的个人信息有错误时，您有权要求我们做出更正或补充。您可以通过“（一）访问您的个人信息”中列明的方式提出更正或补充申请。
        </div>

        <div>
          <div>（三）删除您的个人信息</div>
          您可以通过“（一）访问您的个人信息”中列明的方式删除您的部分个人信息。
          在以下情形中，您可以向我们提出删除个人信息的请求：
          <div> 1、如果我们处理个人信息的行为违反法律法规；</div>
          <div>2、如果我们收集、使用您的个人信息，却未征得您的明确同意；</div>
          <div>3、如果我们处理个人信息的行为违反了与您的约定；</div>
          <div>4、如果您不再使用我们的产品或服务，或您主动注销了账号；</div>
          <div>5、如果我们不再为您提供产品或服务。</div>
          若我们决定响应您的删除请求，我们还将同时通知从我们处获得您的个人信息的第三方，要求其及时删除，除非法律法规另有规定，或这些第三方获得您的独立授权。
          当您从我们的服务中删除信息后，根据法律法规的要求及不同信息的技术条件需要，我们可能无法立即从备份系统中删除相应的信息，在此之前，我们将根据法规要求对相应信息仅进行存储并采取必要的安全保护措施方面的处理。
        </div>

        <div>
          <div>（四）注销账户</div>
          在需要终止使用碳阻迹产品或服务时，您可以通过本隐私政策列明的联系方式联系我们申请注销碳阻迹账户。
          在您主动注销账户之后，我们将停止为您提供产品或服务，根据《中华人民共和国民法典》适用条款删除您的个人信息，或使其匿名化处理。
        </div>

        <div>
          <div>（五）撤回已同意的授权</div>
          您可以通过本隐私政策列明的联系方式联系我们，要求撤回您的已同意的授权。请您注意，撤回已同意的授权后，我们将不再继续处理您相应的个人信息，也无法继续为您提供对应的功能或服务。但您撤回同意的决定，不会影响此前基于您的授权而开展的个人信息处理。
        </div>

        <div>
          <div>（六）约束信息系统自动决策</div>
          在某些业务功能中，我们可能仅依据信息系统、算法在内的非人工自动决策机制做出决定。如果这些决定显著影响您的合法权益，您有权要求我们做出解释，我们也将在不侵害碳阻迹商业秘密或其他用户权益、社会公共利益的前提下提供申诉方法。
        </div>

        <div>
          <div>（七）响应您的上述请求</div>
          为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。
          在以下情形中，按照法律法规要求，我们将无法响应您的请求：
          <div>1、与国家安全、国防安全有关的；</div>
          <div>2、与公共安全、公共卫生、重大公共利益有关的；</div>
          <div>3、与犯罪侦查、起诉、审判和执行判决有关的；</div>
          <div>4、有充分证据表明您存在主观恶意或滥用权利的；</div>
          <div>
            5、响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；
          </div>
          <div>6、涉及商业秘密的。</div>
        </div>
        <div className={styles.title}>六、我们如何处理未成年人的个人信息</div>

        <div>
          我们的产品、网站和服务主要面向成人。如果没有父母或监护人的同意，未成年人不得创建自己的用户账户。
        </div>

        <div>
          对于经父母同意而收集未成年人个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用或公开披露此信息。
        </div>

        <div>
          尽管当地法律和习俗对未成年人的定义不同，但我们将不满 14
          周岁的任何人均视为未成年人。如果我们发现自己在未事先获得可证实的父母同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关数据或采取适当处理。
        </div>

        <div className={styles.title}>七、您的个人信息如何在全球范围转移</div>

        <div>
          我们在中华人民共和国境内运营中收集和产生的个人信息，存储在中国境内，以下情形除外：
        </div>

        <div>1、法律法规有明确规定；</div>

        <div>
          2、向您告知境外接收方的相关信息（例如境外接收方的名称、联系方式、处理您个人信息的目的、方式和种类以及您向境外接收方行使您的权利的方式和程序等），并获得您的明确授权。
        </div>

        <div>
          针对以上情形，我们会确保依据本隐私政策对您的个人信息提供在中华人民共和国境内足够同等的保护。
        </div>

        <div className={styles.title}>八、本政策如何更新</div>

        <div>我们的隐私政策可能变更。</div>

        <div>未经您明确同意，我们不会限制您按照本隐私政策所应享有的权利。</div>

        <div>
          我们会通过在我们网站上发出隐私政策更新版本或以其他方式提醒您隐私政策的更新，也请您访问我们以便及时了解最新的隐私政策。在前述情况下，若您继续使用碳阻迹产品/服务，即表示同意接受修订后的隐私政策并受之约束。
        </div>

        <div>
          对于重大变更，我们还会提供更为显著的通知(包括我们会通过碳阻迹网站公示的方式进行通知)。
        </div>

        <div>本政策所指的重大变更包括但不限于：</div>

        <div>
          1、我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式；
        </div>

        <div>2、我们在控制权方面发生重大变化。如并购重组引起的所有者变更；</div>

        <div>3、个人信息共享、转让或公开披露的主要对象发生变化；</div>

        <div>4、您参与个人信息处理方面的权利及其行使方式发生重大变化；</div>

        <div>
          5、我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；
        </div>

        <div>6、个人信息安全影响评估报告表明存在高风险时。</div>

        <div>
          我们还会将本政策的旧版本存档，供您查阅。若您在本政策修订后继续使用碳阻迹服务，这表示您已充分阅读、理解并接受修订后的本政策并愿意受修订后的本政策约束。
        </div>

        <div className={styles.title}>九、如何联系我们</div>

        <div>
          如果您对本隐私政策有任何疑问、意见或建议，通过以下方式与我们联系：
        </div>

        <div>电子邮件：mail@carbonstop.com</div>

        <div>电话：+86（010）50973498</div>
      </div>
    </div>
  );
}

export default PrivacyPolicyZH;
